import didiSection from "./pages/actives/didi-section";

export const JSONS = {
    productPrice: {
        carModelPrice: {
            searchFormView: [
                { xtype: 'grid', xprops: { colums: '3' }, children:
                    [
                        // { name: 'supplier_code', xtype: 'apiSelect', xprops: {
                        //         allowClear: true,
                        //     url: '/rental/scm/supplier/list',
                        //     labelKey: 'name',valueKey: 'supplier_code',
                        //     placeholder: '请选择供应商', label: '供应商'}, },
                        { name: 'store_code', xtype: 'apiSelect', xprops: {
                                allowClear: true,
                            url: '/rental/scm/store/list',
                            labelKey: 'store_name',valueKey: 'store_code',
                            placeholder: '请选择', label: '门店'
                        }
                        },
                        { name: 'veh_num_type', xtype: 'enumSelect', xprops: {
                                initialValue: -1,
                                enumKey: 'veh_num_type',
                                placeholder: '请选择', allowClear: true, label: '特殊牌照' }, },
                        { name: 'veh_num', xtype: 'input', xprops: {
                                placeholder: '请输入', allowClear: true, label: '车牌号' }, },
                    ]
                },
                { xtype: 'grid', xprops: { colums: '3' }, children:
                    [
                        { name: 'veh_model_code', xtype: 'cascader',
                            xprops: {
                                allowClear: true,
                                placeholder: '请选择', label: '车型' },
                        },
                        { name: 'status', xtype: 'enumSelect', xprops: {
                            enumKey: 'sale_status_finished', initialValue: -1, placeholder: '请选择', allowClear: true, label: '销售规则状态' }, },
                    ]
                },
            ],
            drawerView: [
            ],
        },
        valueAddedPrice: {
            searchFormView: [
                { xtype: 'grid', xprops: { colums: '3' }, children:
                    [
                        // { name: 'supplier_code', xtype: 'apiSelect', xprops: {
                        //         url: '/rental/scm/supplier/list',
                        //         allowClear: true,
                        //         labelKey: 'name',valueKey: 'supplier_code',
                        //         placeholder: '请选择供应商', label: '供应商'}, },
                        { name: 'level', xtype: 'enumSelect', xprops: {
                            enumKey: 'guarantee_rule_level',
                            placeholder: '请选择', allowClear: true, label: '服务类型' }
                        },
                        { name: 'name', xtype: 'input', xprops: {
                            placeholder: '请输入', allowClear: true, label: '服务名称' }, },
                    ]
                },
            ],
            drawerView: [
                { xtype: 'grid', xprops: { colums: '1' }, children:
                       [
                           { name: 'name', xtype: 'input',
                               rules: [{ required: true , message: '请输名称'}],
                               xprops: {
                                   style: {
                                       width: '300px'
                                   },
                                    placeholder: '请输名称', allowClear: true,
                                   label: '模版名称' }, },
                           { name: 'level', xtype: 'serviceTypeAggregation',
                               rules: [{ required: true, message: '请选择服务类型' }],
                               xprops: {
                                   enumKey: 'guarantee_rule_level',
                                   style: {
                                       width: '300px'
                                   },
                                   placeholder: '请选择', allowClear: true, label: '服务类型' }
                           },
                           { name: 'amount', xtype: 'inputNumber',
                               rules: [
                                   { required: true, message: '请输入价格' },
                                   { type: 'number',min: 1, max: 1000, message: `请输入1-1000的正整数` },
                               ],
                               xprops: {
                                   style: {
                                       width: '300px'
                                   },
                                   extra: '优享/尊享保障的价格，填写基于基础保障价格的增量（例如基础保障50元，优享保障120元，那优享保障这里的价格填写为：70元）',
                                   addonAfter: '元/天',
                                   placeholder: '请输价格',
                                   allowClear: true,
                                   label: '价格' }, },
                           {
                               xtype: 'ScopeOfCompensation',
                               xprops: {
                                   style: {
                                       width: '300px'
                                   }
                               }
                           },
                           // { name: 'guarantee_deductible_amount',
                           //     rules: [{ required: true, message: '请输入价格' }],
                           //     xtype: 'input', xprops: {
                           //         extra: '优享/尊享保障的价格，填写基于基础保障价格的增量' +
                           //             '（例如基础保障50元，优享保障120元，那优享保障这里的价格填写为：70元）',
                           //         enumKey: 'f_price_service_types',
                           //         style: {
                           //             width: '300px'
                           //         },
                           //         disabled: true,
                           //         addonAfter: '元',
                           //         placeholder: '请输价格',
                           //         allowClear: true,
                           //         label: '起赔额' }, },
                           // { name: 'contains_tyres_loss', xtype: 'RadioGroup',
                           //     rules: [{ required: true , message: '请选择是否包含轮胎损失'}],
                           //     xprops: {
                           //         style: {
                           //             width: '300px'
                           //         },
                           //         options: [
                           //             {
                           //                 label: '包含',
                           //                 value: 1
                           //             },
                           //             {
                           //                 label: '不包含',
                           //                 value: 2
                           //             }
                           //         ],
                           //         label: '是否包含轮胎损失' },
                           // },
                           // { name: 'contains_glass_loss', xtype: 'RadioGroup',
                           //     rules: [{ required: true , message: '请选择是否包含玻璃损失'}],
                           //     xprops: {
                           //         style: {
                           //             width: '300px'
                           //         },
                           //         options: [
                           //             {
                           //                 label: '包含',
                           //                 value: 1
                           //             },
                           //             {
                           //                 label: '不包含',
                           //                 value: 2
                           //             }
                           //         ],
                           //         label: '是否包含玻璃损失' },
                           // },
                           { name: 'third_amount', xtype: 'inputNumber',
                               rules: [
                                   { required: true , message: '请输入价格'},
                                   { type: 'number',min: 1, max: 500, message: `请输入1-500的正整数` },
                               ],
                               xprops: {
                                   style: {
                                       width: '300px'
                                   },
                                   addonAfter: '万元',
                               placeholder: '请输价格', allowClear: true, label: '第三方保障' }, },
                           { name: ['depreciate'],
                               xtype: 'depreciationCost',
                               rules: [{
                               required: true, message: '请选择折旧费'},],
                               xprops: {
                                   label: '折旧费',
                                   placeholder: '请选择'
                                  }
                           },
                           { name: 'outage', xtype: 'parkingFee',
                               rules: [{ required: true, message: '请选择停运费' }],
                               xprops: {
                                   label: '停运费',
                                   placeholder: '请选择'
                                   }
                           },
                       ]
                },
            ],
        },
        bookingRuleTemplate: {
            searchFormView: [
                { xtype: 'grid', xprops: { colums: '3' }, children:
                    [
                        // { name: 'supplier_code', xtype: 'apiSelect', xprops: {
                        //         url: '/rental/scm/supplier/list',
                        //         allowClear: true,
                        //         labelKey: 'name',valueKey: 'supplier_code',
                        //         placeholder: '请选择供应商', label: '供应商'}, },
                        { name: 'name', xtype: 'input', xprops: { placeholder: '请输入', allowClear: true, label: '模版名称' }, },
                    ]
                },
            ],
            drawerView: [
                { xtype: 'typography', xprops: {}, children:
                    [
                        { name: 'c4', xtype: 'BookingRules', xprops: { placeholder: '请选择模版名称', allowClear: true, label: '' }, },
                    ]
                },
            ],
        },
        servicePolicyTemplate: {
            searchFormView: [
                { xtype: 'grid', xprops: { colums: '3' }, children:
                    [
                        // { name: 'supplier_code', xtype: 'apiSelect', xprops: {
                        //         allowClear: true,
                        //         url: '/rental/scm/supplier/list',
                        //         labelKey: 'name',valueKey: 'supplier_code',
                        //         placeholder: '请选择供应商', label: '供应商'}, },
                        { name: 'name', xtype: 'input', xprops: { placeholder: '请输入', allowClear: true, label: '模版名称' }, },
                    ]
                },
            ],
            drawerView: [
                { xtype: 'grid', xprops: { colums: '1' }, children:
                    [

                        { name: 'service_policy', xtype: 'ServicePolicy', xprops: {} },
                    ]
                },
            ],
        },
        cancelRuleTemplate: {
            searchFormView: [
                { xtype: 'grid', xprops: { colums: '3' }, children:
                    [
                        // { name: 'supplier_code', xtype: 'apiSelect', xprops: {
                        //         allowClear: true,
                        //         url: '/rental/scm/supplier/list',
                        //         labelKey: 'name',valueKey: 'supplier_code',
                        //         placeholder: '请选择供应商', label: '供应商'}, },
                        { name: 'name', xtype: 'input', xprops: { colums: '3',
                                placeholder: '请输入', allowClear: true, label: '模版名称' }, },
                    ]
                },
            ],
            drawerView: [
                { xtype: 'typography', xprops: { colums: '2' }, children:
                    [
                        { name: 'c4', xtype: 'CancelBookingRules', xprops: { placeholder: '请选择模版名称', allowClear: true, label: '' }, },
                    ]
                },
            ],
        },
    },
    orderManagement: {
        orderList: {
            searchFormView: [
                { xtype: 'grid', xprops: { colums: '3' }, children:
                    [
                        { name: 'order_code', xtype: 'input', xprops: { placeholder: '请输入', allowClear: true, label: '订单编号' }, },
                        { name: 'store_code', xtype: 'apiSelect', xprops: {
                                allowClear: true,
                                url: '/rental/scm/store/list',
                                labelKey: 'store_name',valueKey: 'store_code',
                                placeholder: '请选择门店', label: '门店'
                            }
                        },
                        { name: 'driver_customer_name', xtype: 'input', xprops: { placeholder: '请输入', allowClear: true, label: '驾驶人姓名' }, },
                        { name: 'pickup_time', xtype: 'SPRangePicker', xprops: { paramType: 'array', format: 'YYYY-MM-DD', label: '取车时间', style: { width: '100%' } }, },
                        { name: 'return_time', xtype: 'SPRangePicker', xprops: { paramType: 'array', format: 'YYYY-MM-DD', label: '还车时间', style: { width: '100%' } }, },
                        { name: 'order_status', xtype: 'enumSelect', xprops: { enumKey: 'f_order_status', placeholder: '请选择', allowClear: true, label: '订单状态' }, },
                        // { name: 'order_status', xtype: 'SPRadioWithEnum', xprops: { enumKey: 'f_order_status', defaultValue: 0, label: '订单状态', optionType: 'button', buttonStyle: 'solid', size: 'small' }, },
                    ]
                },
            ],
            drawerView: [
                { xtype: 'typography', xprops: { colums: '2' }, children:
                    [
                        { name: 'c4', xtype: 'OrderTab', xprops: { placeholder: '请选择模版名称', allowClear: true, label: '' }, },
                    ]
                },
            ],
        },
    },
    notification: {
        notificationList: {
            searchFormView: [
                {
                    xtype: 'grid', xprops: { colums: '3' }, children:
                        [
                            { name: 'title', xtype: 'input', xprops: { placeholder: '请输入通知标题', label: '通知标题' }, },
                            {
                                name: 'type', xtype: 'enumSelect', xprops: {
                                    initialValue: -1,
                                    enumKey: 'f_msg_type',
                                    placeholder: '请选择通知分类', allowClear: false, label: '通知分类'
                                },
                            },
                            {
                                name: 'read_status', xtype: 'enumSelect', xprops: {
                                    initialValue: -1,
                                    enumKey: 'f_msg_status',
                                    placeholder: '请选择通知状态', allowClear: false, label: '通知状态'
                                },
                            },
                        ]
                },
            ],
        },
        csOrderList: {
            searchFormView: [
                { xtype: 'grid', xprops: { colums: '3' }, children:
                    // todo：确认下这块的字段名
                    [
                        { name: 'order_code', xtype: 'input', xprops: { placeholder: '请输入', allowClear: true, label: '订单编号' }, },
                        { name: 'case_id', xtype: 'input', xprops: { placeholder: '请输入', allowClear: true, label: '工单编号' }, },
                        { name: 'case_status', xtype: 'enumSelect', xprops: { enumKey: 'case_status', placeholder: '请选择', allowClear: true, label: '工单状态' }, },
                        { name: 'store_code', xtype: 'apiSelect', xprops: {
                                allowClear: true,
                                url: '/rental/scm/store/list',
                                labelKey: 'store_name',valueKey: 'store_code',
                                placeholder: '请选择', label: '所属门店'
                            }
                        }
                    ]
                },
            ],
        }
    },
    supplierEntry: {
        baseForm:[
                {
                    xtype: 'grid', xprops: { colums: '2' }, children:
                        [
                            {
                                name: 'read_status', xtype: 'enumSelect', xprops: {
                                    initialValue: -1,
                                    enumKey: 'f_msg_status',
                                    placeholder: '请选择状态', allowClear: true, label: '状态'
                                },
                            },
                            {
                                name: 'read_status', xtype: 'enumSelect', xprops: {
                                    initialValue: -1,
                                    enumKey: 'f_msg_status',
                                    placeholder: '请选择状态', allowClear: true, label: '状态'
                                },
                            },
                        ]
            },
        ]
    },
    actives: {
      didiSection: {
        searchFormView: [
          { xtype: 'grid', xprops: { colums: '3' }, children:
              [
                // { name: 'supplier_code', xtype: 'apiSelect', xprops: {
                //         url: '/rental/scm/supplier/list',
                //         allowClear: true,
                //         labelKey: 'name',valueKey: 'supplier_code',
                //         placeholder: '请选择供应商', label: '供应商'}, },
                { name: 'store_code', xtype: 'apiSelect', xprops: {
                    showSearch: true,
                    allowClear: true,
                    url: '/rental/scm/store/list',
                    labelKey: 'store_name',valueKey: 'store_code',
                    placeholder: '请选择', label: '门店'
                  }
                },
                {
                  name: 'veh_num', xtype: 'SPDeCodeInput',
                  xprops: {
                    placeholder: '请输入', allowClear: true, label: '车牌号'
                  },
                },
                { name: 'veh_model_code', xtype: 'cascader',
                  xprops: {
                    allowClear: true,
                    placeholder: '请选择', label: '车型' },
                },
              ]
          },
          { xtype: 'grid', xprops: { colums: '3' }, children:
              [
                {
                  name: 'status', xtype: 'enumSelect', xprops: {
                    initialValue: -1,
                    enumKey: 'f_didijingxuan_conform',
                    placeholder: '请选择', allowClear: true,
                    label: '是否符合条件'
                  },
                },
              ]
          },
        ],
        drawerView: [
          { xtype: 'grid', xprops: { colums: '1' }, children:
              [
                { name: 'name', xtype: 'input',
                  rules: [{ required: true , message: '请输名称'}],
                  xprops: {
                    style: {
                      width: '300px'
                    },
                    placeholder: '请输名称', allowClear: true,
                    label: '模版名称' }, },
                { name: 'level', xtype: 'serviceTypeAggregation',
                  rules: [{ required: true, message: '请选择服务类型' }],
                  xprops: {
                    enumKey: 'guarantee_rule_level',
                    style: {
                      width: '300px'
                    },
                    placeholder: '请选择', allowClear: true, label: '服务类型' }
                },
                { name: 'amount', xtype: 'inputNumber',
                  rules: [
                    { required: true, message: '请输入价格' },
                    { type: 'number',min: 1, max: 1000, message: `请输入1-1000的正整数` },
                  ],
                  xprops: {
                    style: {
                      width: '300px'
                    },
                    extra: '优享/尊享保障的价格，填写基于基础保障价格的增量（例如基础保障50元，优享保障120元，那优享保障这里的价格填写为：70元）',
                    addonAfter: '元/天',
                    placeholder: '请输价格',
                    allowClear: true,
                    label: '价格' }, },
                {
                  xtype: 'ScopeOfCompensation',
                  xprops: {
                    style: {
                      width: '300px'
                    }
                  }
                },
                // { name: 'guarantee_deductible_amount',
                //     rules: [{ required: true, message: '请输入价格' }],
                //     xtype: 'input', xprops: {
                //         extra: '优享/尊享保障的价格，填写基于基础保障价格的增量' +
                //             '（例如基础保障50元，优享保障120元，那优享保障这里的价格填写为：70元）',
                //         enumKey: 'f_price_service_types',
                //         style: {
                //             width: '300px'
                //         },
                //         disabled: true,
                //         addonAfter: '元',
                //         placeholder: '请输价格',
                //         allowClear: true,
                //         label: '起赔额' }, },
                // { name: 'contains_tyres_loss', xtype: 'RadioGroup',
                //     rules: [{ required: true , message: '请选择是否包含轮胎损失'}],
                //     xprops: {
                //         style: {
                //             width: '300px'
                //         },
                //         options: [
                //             {
                //                 label: '包含',
                //                 value: 1
                //             },
                //             {
                //                 label: '不包含',
                //                 value: 2
                //             }
                //         ],
                //         label: '是否包含轮胎损失' },
                // },
                // { name: 'contains_glass_loss', xtype: 'RadioGroup',
                //     rules: [{ required: true , message: '请选择是否包含玻璃损失'}],
                //     xprops: {
                //         style: {
                //             width: '300px'
                //         },
                //         options: [
                //             {
                //                 label: '包含',
                //                 value: 1
                //             },
                //             {
                //                 label: '不包含',
                //                 value: 2
                //             }
                //         ],
                //         label: '是否包含玻璃损失' },
                // },
                { name: 'third_amount', xtype: 'inputNumber',
                  rules: [
                    { required: true , message: '请输入价格'},
                    { type: 'number',min: 1, max: 500, message: `请输入1-500的正整数` },
                  ],
                  xprops: {
                    style: {
                      width: '300px'
                    },
                    addonAfter: '万元',
                    placeholder: '请输价格', allowClear: true, label: '第三方保障' }, },
                { name: ['depreciate'],
                  xtype: 'depreciationCost',
                  rules: [{
                    required: true, message: '请选择折旧费'},],
                  xprops: {
                    label: '折旧费',
                    placeholder: '请选择'
                  }
                },
                { name: 'outage', xtype: 'parkingFee',
                  rules: [{ required: true, message: '请选择停运费' }],
                  xprops: {
                    label: '停运费',
                    placeholder: '请选择'
                  }
                },
              ]
          },
        ],
      }
    }
};
